<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">
      {{ 'serviceData.financeDetails.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    @if (serviceData$ | async; as serviceData) {
      <!--      Personal information-->
      <div class="d-flex justify-content-between align-items-end">
        <p class="caption mb-1">
          {{ 'common.titleBaseInformation' | translate }}
        </p>
      </div>
      <hr class="mt-0" />
      <div class="row mb-2">
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.partner' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{ serviceData.partner?.name }}
          </div>
        </div>
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.externalId' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{
              serviceData.partner?.externalId ??
                ('serviceData.financeDetails.values.externalIdNotSet'
                  | translate)
            }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.bundles' | translate
          }}</label>
          <div
            class="col-12 col-sm-8"
            [innerHTML]="serviceData.bundleIds | getList: (bundles$ | async)"
          ></div>
        </div>
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.country' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{ serviceData.partner?.address.country }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.name' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{ serviceData.patientInformation.firstName }}
            {{ serviceData.patientInformation.lastName }}
          </div>
        </div>
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.dateOfService' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{ (serviceData.dateOfService | date) ?? '—' }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.notes' | translate
          }}</label>

          <div class="col-12 col-sm-8">
            {{ serviceData.notes ? serviceData.notes : '—' }}
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.nipt.patientState' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{
              serviceDataUtils.getPropertyFromServiceInformation(
                serviceData.serviceInformation,
                'comments'
              ) || '—'
            }}
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-end">
        <p class="caption mb-1">
          {{ 'serviceData.financeDetails.sampleInformation' | translate }}
        </p>
      </div>
      <hr class="mt-0" />
      @if (serviceData.samples?.length) {
        @for (sample of serviceData.samples; track sample.id) {
          <div class="row mb-2">
            <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.kitId' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{ sample.kitId }}
              </div>
            </div>
            <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
              <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
                'serviceData.details.dateOfVenipuncture' | translate
              }}</label>
              <div class="col-12 col-sm-8">
                {{ sample.dateOfVenipuncture | date }}
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="row mb-2">
          <div class="col-12 text-center">
            {{ 'serviceData.financeDetails.noSamplesYet' | translate }}
          </div>
        </div>
      }
      <div class="d-flex justify-content-between align-items-end">
        <p class="caption mb-1">
          {{ 'serviceData.financeDetails.paymentInformation' | translate }}
        </p>
      </div>
      <hr class="mt-0" />
      <div class="row mb-2">
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.payerName' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{ serviceData.paymentInformation.notes || '—' }}
          </div>
        </div>
      </div>
      @let isPartnerPayment =
        serviceData.paymentInformation.paymentType === PaymentType.Partner;
      @if (!isPartnerPayment && (prices$ | async); as prices) {
        <div class="row mb-2">
          <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.endUserPrice' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              @if (prices.endUserPrice !== null) {
                {{ prices.endUserPrice | number: '1.2-2' }}
                {{ prices.currency }}
              } @else {
                —
              }
            </div>
          </div>
          <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
            <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
              'serviceData.details.doctorFee' | translate
            }}</label>
            <div class="col-12 col-sm-8">
              @if (prices.doctorFee !== null) {
                {{ prices.doctorFee | number: '1.2-2' }}
                {{ prices.currency }}
              } @else {
                —
              }
            </div>
          </div>
        </div>
      }
      <div class="row mb-2">
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.doctorInvoice' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{ serviceData.paymentInformation.doctorInvoiceNumber || '—' }}
          </div>
        </div>
        <div class="col-12 col-md-6 row align-items-center mb-3 mb-sm-0">
          <label class="label col-12 col-sm-4 mb-0 text-sm-end">{{
            'serviceData.details.laboratoryInvoice' | translate
          }}</label>
          <div class="col-12 col-sm-8">
            {{ serviceData.paymentInformation.laboratoryInvoiceNumber || '—' }}
          </div>
        </div>
      </div>
      @if (!isPartnerPayment && (prices$ | async)?.eupDiscounts.length) {
        <div class="row mb-2">
          <div class="col-12">
            <p class="caption mb-1">
              {{ 'serviceData.financeDetails.eupDiscounts.title' | translate }}
            </p>
            <app-data-table
              [configuration]="eupDiscountsDataTableConfiguration"
            />
          </div>
        </div>
      }
      <hr class="mt-0" />
      <div class="row">
        <div class="col-12 col-md-6 mb-3 row align-items-center">
          <label
            class="label col-12 col-sm-4 mb-0 text-sm-end"
            for="gpInvoice"
            translate="serviceData.financeDetails.gpInvoice"
          ></label>
          <div class="col-12 col-sm-8 d-flex">
            <div class="col-4 input-group form-inline w-100 mb-2">
              <input
                type="number"
                id="gpInvoice"
                class="form-control"
                (appCtrlS)="saveGpInvoice()"
                placeholder="{{
                  'serviceData.financeDetails.placeholders.gpInvoice'
                    | translate
                }}"
                [formControl]="gpInvoiceField"
              />
              <button
                type="button"
                class="icon-btn-suffix icon-btn-lg"
                (click)="saveGpInvoice()"
                [disabled]="!gpInvoiceField.dirty"
              >
                <i class="fa-light fa-floppy-disk"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3 row align-items-center">
          <label
            class="label col-12 col-sm-4 mb-0 text-sm-end"
            for="laboratoryPrice"
            translate="serviceData.financeDetails.laboratoryPrice"
          ></label>
          <div class="col-12 col-sm-8 d-flex">
            <div class="col-4 input-group form-inline w-100 mb-2">
              <input
                type="number"
                id="laboratoryPrice"
                class="form-control"
                [readOnly]="!!serviceData.invoice.paid"
                [disabled]="!!serviceData.invoice.paid"
                (appCtrlS)="saveLaboratoryPrice()"
                placeholder="{{
                  'serviceData.financeDetails.placeholders.laboratoryPrice'
                    | translate
                }}"
                [formControl]="laboratoryPriceField"
              />
              <button
                type="button"
                class="icon-btn-suffix icon-btn-lg"
                (click)="saveLaboratoryPrice()"
                [disabled]="!laboratoryPriceField.dirty"
              >
                <i class="fa-light fa-floppy-disk"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mb-3 row align-items-center">
          <label
            class="label col-12 col-sm-4 mb-0 text-sm-end"
            for="paymentType"
            translate="serviceData.financeDetails.paymentType"
          ></label>
          <div class="col-12 col-sm-8 d-flex">
            <app-select
              id="paymentType"
              class="flex-fill mw-100"
              [disabled]="!!serviceData.invoice.paid"
              [placeholder]="
                'serviceData.financeDetails.placeholders.paymentType'
                  | translate
              "
              [formControl]="paymentTypeField"
            >
              @for (
                paymentType of Object.keys(PaymentType);
                track paymentType
              ) {
                <app-select-option
                  [value]="paymentType"
                  [label]="paymentType"
                />
              }
            </app-select>
            <button
              type="button"
              class="icon-btn-suffix icon-btn-lg"
              (click)="savePaymentType()"
              [disabled]="!paymentTypeField.dirty"
            >
              <i class="fa-light fa-floppy-disk"></i>
            </button>
          </div>
        </div>
        <div class="col-12 col-md-6 mb-3 row align-items-center">
          <label
            class="label col-12 col-sm-4 mb-0 text-sm-end"
            for="discount"
            translate="serviceData.financeDetails.discount"
          ></label>
          <div class="col-12 col-sm-8 d-flex">
            <div class="col-4 input-group form-inline w-100 mb-2">
              <input
                type="number"
                id="discount"
                class="form-control"
                [readOnly]="!!serviceData.invoice.paid"
                [disabled]="!!serviceData.invoice.paid"
                (appCtrlS)="saveDiscount()"
                placeholder="{{
                  'serviceData.financeDetails.placeholders.discount' | translate
                }}"
                [formControl]="discountField"
              />
              <button
                type="button"
                class="icon-btn-suffix icon-btn-lg"
                (click)="saveDiscount()"
                [disabled]="!discountField.dirty"
              >
                <i class="fa-light fa-floppy-disk"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-0" />

      <div class="row mb-2">
        <div class="offset-md-2 col-11 col-md-9 align-items-center">
          <div class="form-check form-switch ms-2">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="sepaSwitch"
              [formControl]="sepaField"
              (change)="
                toggleSepa(serviceData.invoice.id, $event.target.checked)
              "
            />
            <label class="form-check-label ps-3" for="sepaSwitch">{{
              'serviceData.financeDetails.sepaContract' | translate
            }}</label>
          </div>
          <div class="d-flex mt-3">
            <div
              class="d-flex flex-fill flex-wrap input-group"
              [formGroup]="paymentFormGroup"
            >
              <input
                ngbDatepicker
                class="form-control payment-date me-2 mb-3"
                type="text"
                [placeholder]="
                  'serviceData.financeDetails.placeholders.date' | translate
                "
                container="body"
                #paymentDatePicker="ngbDatepicker"
                formControlName="paymentDate"
                (click)="paymentDatePicker.toggle()"
              />
              <input
                class="form-control payment-price me-2 mb-3"
                type="number"
                [placeholder]="
                  'serviceData.financeDetails.placeholders.price' | translate
                "
                formControlName="price"
              />
              <app-currencies-typeahead
                class="d-flex flex-fill"
                [control]="$any(paymentFormGroup.get('currency'))"
              />
              <app-select
                formControlName="service"
                class="payment-service me-2 mb-3"
                [placeholder]="
                  'serviceData.financeDetails.placeholders.paymentService'
                    | translate
                "
              >
                @for (
                  paymentService of PaymentService | keyvalue;
                  track paymentService
                ) {
                  <app-select-option
                    [value]="paymentService.value"
                    [label]="
                      'serviceData.financeDetails.paymentServices.' +
                        paymentService.value | translate
                    "
                  />
                }
              </app-select>
              <input
                class="form-control payment-payer-name me-2 mb-3"
                type="text"
                [placeholder]="
                  'serviceData.financeDetails.placeholders.payerName'
                    | translate
                "
                formControlName="notes"
              />
            </div>
            <div>
              <button
                class="icon-btn icon-btn-lg"
                [disabled]="
                  paymentFormGroup.invalid || serviceData.invoice.paid
                "
                (click)="addPayment(serviceData.invoice.id)"
                type="button"
              >
                <i class="fa-light fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="row">
            <app-data-table
              [configuration]="paymentsDataTableConfiguration"
            ></app-data-table>
          </div>

          <div class="d-flex">
            <div class="sum flex-fill pt-3">
              {{ 'serviceData.financeDetails.sumPrice' | translate }}:
              {{ sumPrice$ | async }}
            </div>
            <div class="text-end mt-3">
              @if (serviceData.invoice.paid) {
                <span
                  class="bg-success text-light px-3 py-2 mb-2 rounded d-inline-block"
                  >{{
                    'serviceData.financeDetails.servicePaid' | translate
                  }}</span
                ><br />
                <button
                  *appRequirePermission="'finance.revokePaidInFull'"
                  class="btn btn-clear btn-sm"
                  [disabled]="paymentActionInProgress()"
                  (click)="revokePaidInFull()"
                >
                  {{
                    'serviceData.financeDetails.actions.revokePaidInFull'
                      | translate
                  }}
                </button>
              } @else {
                <button
                  class="btn btn-primary btn-sm"
                  [disabled]="
                    !(paidInFullEnabled$ | async) || paymentActionInProgress()
                  "
                  (click)="markAsPaidInFull()"
                >
                  {{
                    'serviceData.financeDetails.actions.paidInFull' | translate
                  }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="py-4 loading"></div>
    }
  </div>
  <div class="modal-footer">
    <button class="btn btn-clear" (click)="modalRef.close()">
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
